import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import PageBanner from 'components/banners/PageBanner';

function PressReleaseDetailsThree() {
  return (
    <div>
      <Helmet>
        <title>Press Releases - CAP60</title>
        <meta
          name="description"
          content="Press release is a tool made to announce something that is newsworthy in the most objective way possible. Read all press release for getting more information!."
        />
        <meta name="keywords" content="press release, cap60 press release" />
      </Helmet>
      <PageBanner title="North Dakota Selects CAP60 for Data Management Needs" />
      <Container>
        <div className="py-5">
          <Row>
            <Col md={3}>
              <p>
                <span className="font-weight-bold">DATE:</span>{' '}
                <span>July 12, 2017</span>
              </p>
            </Col>
            <Col md={3}>
              <p>
                <span className="font-weight-bold mr-2">CATEGORY:</span>
                <Badge variant="dark">Press Releases</Badge>
              </p>
            </Col>
          </Row>
          <h6 className="mt-4 mb-3 font-weight-bold">
            LOS ANGELES, CA – JULY 12, 2017
          </h6>

          <p>
            North Dakota has chosen CAP60 as their state-mandated, data
            management solution for all Community Action Agencies in the state.
            The decision was made after an intensive review of numerous case
            management software solutions which revealed that the CAP60 system
            was easiest to use and customize.
          </p>

          <p>
            Andrea Olson, Executive Director of the Community Action Partnership
            of North Dakota feels that CAP60 best understood the needs and
            operations of a non-profit agency. “CAP60 stood out to us because of
            the variety of features available, the ease of data entry, and
            software aesthetics. It didn’t hurt that we received positive
            recommendations from other agencies whose opinion we value very
            much. Knowing that CAP60 customer base is exclusive to CAA’s was
            also very appealing.” Andrea Olso
          </p>
          <p>
            The state of North Dakota has seven CAP agencies which provide
            nearly 60,000 services to more than 11,000 clients. With a
            comprehensive system in place, North Dakota agencies can record all
            community service efforts and referrals; volunteer information and
            transactions; and staff and board training events to assist with
            compliance and leveraging of funding.
          </p>

          <p>
            North Dakota is the one of four states that has recently chosen
            CAP60 as their state-mandated data management provider. Company
            President, Hamid Kohan lauded the company’s experience saying, “For
            15 years, we’ve been listening, then responding to the
            organizations’ needs. We think that has paid off in CAP60 offering
            the best data management tools in the country.”
          </p>

          <h6>About CAP60:</h6>
          <p>
            CAP60 is a provider of comprehensive Agency and Program Management
            tools that are designed for use by Community Action Programs,
            Domestic Violence & Shelters, and other, as well as other Health and
            Human Services organizations. CAP60 provides services to Agencies in
            over 35 States nationwide, the U.S. Virgin Islands, and Canada.
            CAP60’s customized applications are designed to meet the data
            collection, tracking, and reporting needs of all aspects of an
            agency. For more information please visit www.cap60.com , email
            sales@cap60.com, or call <b>917-668-9174.</b>
          </p>
        </div>
      </Container>
    </div>
  );
}

export default PressReleaseDetailsThree;
